import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { setOverrides } from "../lib/i18n";

const SiteCtx = createContext({});
export const useSite = () => useContext(SiteCtx);

export function SiteProvider({ children }) {
  const [data, setData] = useState({ site: null, categories: [] });

  const load = async () => {
    const [s, c] = await Promise.all([api.get("/site"), api.get("/categories")]);
    setOverrides(s.data.translations_pl);
    setData({ ...s.data, categories: c.data });
  };

  useEffect(() => { load().catch(() => {}); }, []);

  useEffect(() => {
    const c = data.site?.colors;
    if (!c) return;
    const r = document.documentElement.style;
    const rgb = (h) => { const m = /^#?([0-9a-f]{6})$/i.exec(h || ""); if (!m) return null; const n = parseInt(m[1], 16); return `${n >> 16} ${(n >> 8) & 255} ${n & 255}`; };
    [["--c-primary", c.primary], ["--c-wood", c.wood], ["--c-accent", c.accent], ["--c-bg", c.background]].forEach(([k, v]) => { const x = rgb(v); if (x) r.setProperty(k, x); });
  }, [data.site]);

  return <SiteCtx.Provider value={{ ...data, reload: load }}>{children}</SiteCtx.Provider>;
}
